import { SET_PAYMENT_HISTORY } from '../actions/type'

const initialState = {
    paymentHistoryList: []
}

const paymentHistory = (state = initialState, action) => {
    switch (action.type) {
        case SET_PAYMENT_HISTORY: {
            const payload = action.payload;
            return { ...state, ...payload };
        }
        default:
            return state
    }
}

export default paymentHistory